export function registerServiceWorker(): void {
    if (typeof window === 'undefined') {
        return;
    }

    if (!('serviceWorker' in navigator)) {
        return;
    }

    if (import.meta.env.DEV) {
        return;
    }

    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/sw.js', { scope: '/' })
            .catch((error: unknown) => {
                // eslint-disable-next-line no-console
                console.warn('Service worker registration failed', error);
            });
    });
}
